import { ConfirmationEmailInterface } from 'modules/digital-product/types/confirmation-email-interface'
import React, { FC } from 'react'
import DashboardMailEditor from 'shared/components/dashboard-mail-editor'
import { SubstituteInterface } from 'shared/components/dashboard-mail-editor/components/substitutes-block'
import { EmailErrorType } from 'shared/components/dashboard-mail-editor/types/email-interface'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

type Props = {
  onChange: (data: ConfirmationEmailInterface) => void
  errors: EmailErrorType
  tempState: ConfirmationEmailInterface
}

export const FILE_LINKS_SUBSTITUTE = 'downloadable_file_links'

export const PRODUCT_NAME_SUBSTITUTE = 'product_name'

export const ConfirmationEmailEditor: FC<Props> = ({ onChange, errors, tempState }) => {
  const { t } = useLocoTranslation()
  const productDownloadSubstitutes: SubstituteInterface[] = [
    {
      slug: 'customer_name',
      name: t('dashboard.store.product.download.substitutions.customer_name'),
    },
    {
      slug: 'my_username',
      name: t('dashboard.store.product.download.substitutions.my_username'),
    },
    {
      slug: PRODUCT_NAME_SUBSTITUTE,
      name: t('dashboard.store.product.download.substitutions.product_name'),
    },
    {
      slug: FILE_LINKS_SUBSTITUTE,
      name: t('dashboard.store.product.download.substitutions.product_files'),
    },
  ]
  return (
    <DashboardMailEditor
      additionalSubstitutes={productDownloadSubstitutes}
      withoutAttachments={true}
      isPreFetching={false}
      errors={errors}
      tempState={tempState}
      onChangeEmail={onChange}
      inModal
    />
  )
}
